import Axios from "axios";
export const client = (config)=>{
    const instance = Axios.create({
        baseURL: config.baseURL || process?.env?.VW_UNIFIED_API_URL || window?.process?.env?.VW_UNIFIED_API_URL || undefined,
        paramsSerializer: {
            indexes: null
        }
    });
    return instance({
        ...config
    }).then(({ data })=>{
        return Promise.resolve(data);
    }).catch((error)=>{
        return Promise.reject({
            ...error?.response?.data?.code ? {
                code: error.response.data.code
            } : {},
            message: (error?.response?.data?.message || error?.response?.data?.details) ?? 'an unknown error has occurred',
            ...error?.response?.data?.meta ? {
                meta: error.response.data.meta
            } : {},
            status: error?.status ?? error?.response?.status ?? error?.response?.data?.status ?? 500
        });
    });
};

//# sourceMappingURL=client.js.map